import { internalChatMessages } from 'messages';
import { OmniChannelMessageDto, OmniChannelSenderDto } from 'types';

export const calculateHeightOmniMessageSystem = (
  message: OmniChannelMessageDto,
  props?: {
    isFirstOfSender?: boolean;
    isGroup?: boolean;
    isMe?: boolean;
    sender?: OmniChannelSenderDto;
  }
): number => {
  if (!message) return 0;

  const clone = document.createElement('div');
  clone.className = 'relative min-w-[70px] max-w-[700px] whitespace-pre-wrap break-words px-3 py-2 text-center text-sm';
  clone.innerHTML = `${props?.isMe ? internalChatMessages.you : props?.sender?.senderName} ${message.content}`;
  document.body.appendChild(clone);
  const height = clone.offsetHeight;
  document.body.removeChild(clone);
  return height;
};
